import * as React from "react";
import { Control, FieldPathValue, FieldValues, Path, useController } from "react-hook-form";
import { CheckboxProps, Form, FormCheckbox, FormInputProps } from "semantic-ui-react";
import * as moment from "moment";

interface SemanticReactHookFormsWeekDaysSelectorProps<
    TFormModel extends FieldValues,
    TName extends Path<TFormModel>
> {
    name: FieldPathValue<TFormModel, TName> extends FormInputProps["value"] ? TName : never;
    control: Control<TFormModel>;
    disabled?: boolean;
    label: string;
}

export const SemanticReactHookFormsWeekDaysSelector = <
    TFormModel extends FieldValues,
    TName extends Path<TFormModel>
>({ control, name, label, ...props }: SemanticReactHookFormsWeekDaysSelectorProps<TFormModel, TName>) => {
    const {
        field: { ref, ...field }
    } = useController({
        name,
        control,
        disabled: props.disabled
    });

    const onChange = React.useCallback((_, data: CheckboxProps) => {
        const { checked } = data;
        field.onChange(checked ? [...field.value, data.value] : field.value.filter((d: number) => d !== data.value));
    } ,[field]);

    return (
        <Form.Field>
            <label>{label}</label>
            <div className="day-selector">
                {moment.weekdaysShort(true).map((day, index) =>
                    (<div key={index} className="field-wrapper">
                        <FormCheckbox
                            label={day}
                            {...field}
                            type="checkbox"
                            checked={field.value && field.value.indexOf(index) !== -1}
                            onChange={onChange}
                            value={index}
                        />
                    </div>)
                )}
            </div>
        </Form.Field>
    );;
};
